export const STATUS_FILTER_VALUES = {
    REGISTERED: 1,
    NOT_REGISTERED: 0,
};
